import React, { useEffect, useState, Fragment, useRef } from 'react'
import {Card, Col, Form, Row, Toast, Container} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {validaConvenio, validaNumeros, formatearNumero, isValidParam} from '../../../../common/Formatos'
import SolicitudEnProceso from './solicitudEnProceso'
import Grilla from './grilla';
import Mensajes from '../../../mensajes';

const RecobroGestionado = ({ formik, setMontoPropuestoNoFormat ,setMontoNetoCompara,  showToast={showToast},
  setShowToast={setShowToast}}) => {
  
  const data_solicitud_modal = useSelector((state) => state.solicitudDescuentoReducer)
  const { cfg_form17, comboMotivoDescuento, respuestaModalSolicitud } =  data_solicitud_modal
    
  const data_judicial = useSelector((state) => state.procesoJudicialReducer)
  const {cleanRef} = data_judicial
  //Data de CIA
  const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
  const {solicitudDescuento, montosInformados} = data_modal_cia
  const fileRef = useRef();
  const [codMotivoSolicitud, setCodMotivoSolicitud] = useState('')
  const [comentario, setComentario] = useState('')

  const [open, setOpen] = React.useState(false)
  const [hidden, setHidden] = React.useState(false)

  //Estados CIA Carta
  const [convenio, setConvenio] = useState(0)
  const [convenioOld, setConvenioOld] = useState(0)
  const [miRecobro, setMiRecobro] = useState(0)
  const [recobroNoFormato, setRecobroNoFormato] = useState(0)
  const [miMontoNeto, setMiMontoNeto] = useState(0)
  const [codMonedaMI, setCodMonedaMI] = useState(0)
  const dispatch = useDispatch()

  useEffect(()=>{
    setMontoNetoCompara(miMontoNeto)
  },[miMontoNeto])

useEffect(() => {
  setMontoPropuestoNoFormat(recobroNoFormato)  
}, [recobroNoFormato])
useEffect(()=>{
  if(cleanRef){
      fileRef.current.value = "";
  }
},[cleanRef])

useEffect(() => {
  setMiMontoNeto(montosInformados && montosInformados.montosInformados[0]['MontoCosto']);
  setCodMonedaMI(montosInformados && montosInformados.montosInformados[0]['CodMoneda']);
}, [montosInformados])

useEffect(() => {
  
  let codMoneda = montosInformados && isValidParam(montosInformados.montosInformados[0]['CodMoneda']) ? montosInformados.montosInformados[0]['CodMoneda'] : 30001;
  let montoRecobro = montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobro']) ? montosInformados.montosInformados[0]['MontoRecobro'] : 0;
  let porConvenido = montosInformados && isValidParam(montosInformados.montosInformados[0]['PorConvenido']) ? montosInformados.montosInformados[0]['PorConvenido'] : '';

  setMiRecobro(formatearNumero(montoRecobro, !codMoneda == 30001));
  setConvenio(porConvenido);
  setRecobroNoFormato(montoRecobro);

  if (montosInformados && montosInformados.montosInformados[0]['MontoRecobro'] === null && montosInformados.montosInformados[0]['MontoRecobro'] === '') {
    setConvenio(75)
    setMiRecobro(miMontoNeto && formatearNumero(miMontoNeto*75/100, false))
    setConvenioOld(porConvenido)
  } 
}, [montosInformados])

const convertirFecha = (fecha) => {
  if (fecha !== null && typeof fecha !== undefined) {
    const [dia, mes, ano] = fecha?.split('-')
    const fechaFormat = [ano, mes, dia].join('-')

    return fechaFormat
  } else return null
}
const handleOpen = () => {
  setOpen(true)
}

const handleClose = () => {
  setOpen(false)
}
const handleAction = (action) => {
  console.log(action)
}
const handleCloseToast = () => {
  setShowToast(false);
}
 
  return (
    <>
      <style type='text/css'>
        {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    `}
      </style>

    
        <Card>
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form17
              ? cfg_form17.cfg_form17['soldescuento-title-solicitud']
              : ''}
          </Card.Header>
          <Container>
            <Container>
              {(cfg_form17 && solicitudDescuento && solicitudDescuento.solicitudDescuento && solicitudDescuento.solicitudDescuento.length===0 )||(solicitudDescuento && solicitudDescuento.solicitudDescuento&&  solicitudDescuento.solicitudDescuento[0]!==undefined && solicitudDescuento.solicitudDescuento[0]['idEstadoSolicitud']!==248000 )? (
                <div>
                    <Row>
                        <Col md='2'>
                        <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {cfg_form17.cfg_form17['soldescuento-subtitle1-solicitud']}
                        </Form.Label>{' '}
                        <br />
                        </Col>
                    </Row>
                    <Container>
                      <Row>
                        <Col md="3">
                          <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form17.cfg_form17['soldescuento-lbl-moneda']}
                          </Form.Label>
                          <br />
                          <Form.Text className='mt-3'>
                            {montosInformados && isValidParam (montosInformados.montosInformados[0]['GlosaMoneda']) ? 
                              montosInformados.montosInformados[0]['GlosaMoneda']
                              : ''
                            }
                          </Form.Text>
                        </Col>
                        <Col md='3'>
                          <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                            {cfg_form17.cfg_form17[ 'soldescuento-lbl-mtoneto'] }
                          </Form.Label>{' '}
                          <br />
                          <Form.Text className='mt-3'>
                            {montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoPago']) ?     
                              formatearNumero(montosInformados.montosInformados[0]['MontoCosto'], !codMonedaMI == 30001)   
                              : ''
                            }                            
                          </Form.Text>
                        </Col>
                        <Col md='3'> 
                          <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form17.cfg_form17['soldescuento-lbl-porcconv'] }
                          </Form.Label>
                          <br />
                          <Form.Text className='mt-3'>
                            {montosInformados && isValidParam(montosInformados.montosInformados[0]['PorConvenido']) ?                        
                              montosInformados.montosInformados[0]['PorConvenido']                          
                              : ''
                            }                            
                          </Form.Text>
                        </Col>
                        <Col md='3'>
                          <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form17.cfg_form17['soldescuento-lbl-mtorecobro']}
                          </Form.Label>
                          <br />
                          <Form.Text className='mt-3'>
                            {montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobro']) ?     
                              formatearNumero(montosInformados.montosInformados[0]['MontoRecobro'], !codMonedaMI == 30001)   
                              : ''
                            }                            
                          </Form.Text>
                        </Col>
                      </Row>
                  </Container>                  
                  <hr
                    style={{
                      color: '#04005D',
                      height: '1.5px',
                      marginTop: '10px'
                    }}
                  ></hr>
                 <Row>
                        <Col md='3'>
                        <Form.Label
                            className='mb-0 mt-3'
                            style={{ fontWeight: 'bold', fontSize: '16px' }}
                        >
                            {cfg_form17.cfg_form17['soldescuento-subtitle2-solicitud']}
                        </Form.Label>{' '}
                        <br />
                        </Col>
                    </Row>
                    <Container>
                      <Row  className="mb-4">
                      <Col md="3">
                        <Form.Label
                          className='mt-2'
                          style={{ fontWeight: 'bold', fontSize: '14px' }}
                        >
                          {cfg_form17.cfg_form17['soldescuento-lbl-monedasoldcto']}
                        </Form.Label>
                        <br />
                        <Form.Text className='mt-3'>
                          {montosInformados &&
                          montosInformados.montosInformados[0][
                            'GlosaMoneda'
                          ] !== undefined &&
                          montosInformados.montosInformados[0][
                            'GlosaMoneda'
                          ] !== null &&
                          montosInformados.montosInformados[0][
                            'GlosaMoneda'
                          ] !== ''
                            ? montosInformados.montosInformados[0][
                                'GlosaMoneda'
                              ]
                            : ''}
                        </Form.Text>
                      </Col>
                      <Col md='3'>
                        <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {cfg_form17.cfg_form17['soldescuento-input-propuestarec'] + ' *'}
                        </Form.Label>{' '}
                        <br />
                        <Form.Control
                          className='mt-2'
                          aria-label='Default select example'
                          onKeyDown={(e) => validaNumeros(e)}
                          onBlur={() => {
                            setMiRecobro(formatearNumero(miRecobro, !codMonedaMI == 30001))
                          }}
                          onFocus={() => setMiRecobro(recobroNoFormato)}
                          onChange={(e) => {
                            formik.handleChange(e)
                            setMiRecobro(e.target.value)
                            setRecobroNoFormato(e.target.value)
                            if (isValidParam(miMontoNeto)) {
                              setConvenio(parseFloat((e.target.value * 100) / miMontoNeto).toFixed(2));
                            } else {
                              setConvenio(0)
                            }
                          }}
                          name='montoPropuesto'
                          value={(formik.values.montoPropuesto = miRecobro)}
                          error={formik.errors.montoPropuesto}
                        ></Form.Control>
                        {formik.errors.montoPropuesto ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.montoPropuesto}
                          </Form.Text>
                        ) : (
                          ''
                        )}

                      </Col>
                      <Col md='3'>
                        <Form.Label
                          className='mt-3'
                          style={{ fontWeight: 'bold', fontSize: '14px' }}
                        >
                          {cfg_form17.cfg_form17[
                            'soldescuento-input-porcpropto'
                          ] + ' *'}
                        </Form.Label>
                        <br />
                        <Form.Control
                        // className='m'
                          aria-label='Default select example'
                          onKeyDown={(e) => validaConvenio(e)}
                          type='number'
                          onChange={(e) => {
                            formik.handleChange(e)
                            setConvenio(e.target.value)

                            let monto = miMontoNeto && (miMontoNeto * e.target.value) / 100 
                            setMiRecobro(formatearNumero(monto, !codMonedaMI == 30001))
                            setRecobroNoFormato(monto)
                            
                          }}
                          onBlur={() => {
                            if (
                              convenio !== '' &&
                              convenio !== null &&
                              convenio !== undefined
                            ) {
                              if (convenio.includes('.'))
                                setConvenio(parseFloat(convenio).toFixed(2))
                              else setConvenio(convenio)
                            }
                          }}
                          name='porcPropuesto'
                          value={(formik.values.porcPropuesto = convenio)}
                          error={formik.errors.porcPropuesto}
                        ></Form.Control>
                          {formik.errors.porcPropuesto ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.porcPropuesto}
                          </Form.Text>
                        ) : (
                          ''
                        )}

                      </Col>
                      
                    </Row>
                    <Row>                    
                      <Col md="4">
                          <Form.Label
                            className='mb-0 mt-2'
                            style={{ fontWeight: 'bold', fontSize: '14px' }}
                          >
                            {cfg_form17.cfg_form17['soldescuento-cmb-motivodcto']+" *"}
                          </Form.Label>
                          <br />
                          <Form.Select
                          className='mt-2'
                          aria-label='Default select example'                       
                          onChange={(e) => {
                            formik.handleChange(e)
                            setCodMotivoSolicitud(e.target.value)
                          
                          }}
                          name='codMotivoSolicitud'
                          value={(formik.values.codMotivoSolicitud = codMotivoSolicitud)}
                          //error={formik.errors.codHitoContacto}
                        >
                          <option value={''}>Seleccione...</option>
                          {comboMotivoDescuento &&
                            comboMotivoDescuento.comboMotivoDescuento
                              .filter(p => p.agrupacion === 246001)
                              ?.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.nombre}
                              </option>
                            ))}
                        </Form.Select>
                        {formik.errors.codMotivoSolicitud ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.codMotivoSolicitud}
                          </Form.Text>
                        ) : (
                          ''
                        )}
                        </Col>
                        <Col md='8'>
                          <Form.Label
                            className='mb-0 mt-2'
                            style={{ fontWeight: 'bold', fontSize: '14px' }}
                          >
                            {cfg_form17.cfg_form17[
                              'soldescuento-input-comentario'
                            ]}
                          </Form.Label>{' '}
                          <br />
                          <Form.Control
                            as='textarea'
                            className='mb-0 mt-2'
                            rows={2}
                            onChange={(e) => {
                              formik.handleChange(e)
                              setComentario(e.target.value)
                            }}
                            name='comentario'
                            value={
                              (formik.values.comentario = comentario)
                            }
                            error={formik.errors.comentario}
                          />
                        {formik.errors.comentario ? (
                          <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.comentario}
                          </Form.Text>
                        ) : (
                          ''
                        )}
                      
                      </Col>
                      <Col>
                        {respuestaModalSolicitud && 
                          <Mensajes
                              showToast={showToast}
                              handleCloseToast={handleCloseToast}
                              delay={5000}
                              responseData={respuestaModalSolicitud?.respuestaModalSolicitud}
                          ></Mensajes>
                        }
                      </Col>
                      
                    </Row>
                    <Row>
                    <Col md='9'>
                    <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form17.cfg_form17[
                            'soldescuento-lbl-subirdcto'
                          ]
                        }
                      </Form.Label>
                      <Form.Group className="position-relative mb-2 mt-1">
                      <Form.Control ref={fileRef} type="file" name="file"
                          onChange={event => { formik.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                          isInvalid={!!formik.errors.file}
                          isValid={formik.touched.file && !formik.errors.file}
                      />
                      <Form.Text className="text-muted">Tamaño máximo del archivo: 10MB</Form.Text>
                      <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  </Container>
                  <Grilla/>
                </div>
              ) : (
                  <SolicitudEnProceso/>
                
              )
              }
            </Container>
          </Container>
        </Card>
      
    </>
  )
}

export default RecobroGestionado
